import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const SlideModalRoundHTML: FC = () => {
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);

  const modalLeftUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAADACAMAAADMWpbkAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABRUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAwMF9fX2BgYH9/f4CAgP///8lIQFcAAAAUdFJOUwAQIDBAUF9gcH+Aj5Cfr7C/z9/v2BEvPAAAA0ZJREFUeNrV3MF2mzAQhWGBTaFYOFi6tVu9/4N24ZwmbhzQSPoXZp1zv2OBCIgZOUkxhHVd5mk4dK79oYcjrqfpSAL343IaehSQpMsysIAknceeBSStY8cCUlyOLCApjDAghaVnAUmlhAQTEkyYAIUJBqQwwIB5nOyAcVqo5LD8iCLA8iNUeJw6GFDoYUBxhAHpJw3o3MFAzokQLahWOMCA4gEGpB80sC20ADZHSbSgNkIPAxvzQa2EDgZ0poHv7q3tgG+mQ0Pg+aXUEHh+olsCOtGABhp4chraAlppQBMNxA4GvtwymgM60kCgAc008HieRf8EAniYzwSghQbU04CngU8XEgN8upBE/wQI+LhtU8BKA/9uqhjgq4Ffeae5OP+afm//wVgHXFPaEdYq4JpSSml7lLoK4J5/y5kKXP77GHH579cRl/8+18D8+1wD8+9PSGD+/UIl8zWaAVu+vBUw5utiBKz5UmcC7Pk6WICCfE0GoCRfPh8oyteaDZTlK+YChflS59h8HRybr8Gx+Zocmy/v2Hwtjs3Xm2PztTo2X8Gx+TtAfb6iY/MlB+dvAG3yN4BbSimlKwc0ErZOchNh8zJtIMTtiVYv7MzkemEPqBbW3dt1pbAPVApLxr/MKmHO+adfI0xZjy0VwpD34FUuHDIfHYuFLvfht1CI+Y/vZcJqeAEpErzlFapEmEwvgQXC0fYaaxesL+JW4WJeSjAK3r4YYhOGguUck9CXLEgZhEvZklq+sBQuCmYLQ+myZq5QvjCbJ7xVLC1nCWPN4vgtY3G8r1rev6WU/uz9L6j6QHHbya/9QMF/YsmaZa/8mSvQH+pGGAj019iFBnoYWF69aAAve6ALNxa49OSxchMAplcvYBpgYIGLyL7U5mK3aQhY4FLEQBdTjnA5qH/xkly8qHiEy6LnFy9Np4vr6faA0L94iwbdZDKybTI7fWno+LcAItxsRbeL0Q1vdMve/Nptk3Tjp2dbV2N+G3RR/sq2D0dTozhz8dc0oVt3TjCOzuwcCMS5YG8Jy7M/upVB9OhmDEWDkw+sU8W+Hhljg27pgW5KEquGZg8I/thmJ51n4Rc/ttum5/9R8VPjPYB0317ovHhme6G/vhN0TU4ZtDsAAAAASUVORK5CYII=';
  const modalRightUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAADACAMAAADMWpbkAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABUUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAwMF9fX2BgYH9/f4CAgP///4EBKK0AAAAVdFJOUwAQIDBAUF9gb3B/gI+Qn6Cvv8/f7w6Awy0AAANNSURBVHjaxdxrc+IgGAVggto0NhcjHNut//9/btTO7GpV3gunzWfnPMMlCUEghOpXs9p0/bibU8oAKkd3/XxK/e+qF972e9y56oSv+4QHV4X07rZWagJNO+P55Ypf9xmgAUvVQHCZ47cZ4AGxF8bbgDhCfhErxwjo4tXAOgFEoNkBTOA1gwnEGWACmwwm0PQAE4gJVOAlgwpsASZg6fwawFH9IsCbXwJWGVTAnw9a95QALwAVWIELVKj/p4C7fxaAWvmPgKZW/iNgBy6wBRdowQVi5gL1GvgB0IMLtOACMZGBEVygcgV9A2pX0DegdgXdAhuQgUQGXsEFYiIDI7hABBkYyQCnAGAXAOwCgF0AMG/iK6AFGUhkYA0yMJKBpjDUOniBQhP/Ob47gbmQf7QLgrv4cDw6BEkNfXgE0eeGRzgDxV85BOFgxS5I7zKzcAL2IAryV41RUIwXbcICDGAK0iYwC5K7wCUo3zV6IYQOVEHRxjah9C5wCyGoJyZ0Qmj0jxeVYJpb1Ai2D0uFoOyleiG8gSuECVwhzOAKdkAoeMbtIsH1YSARgmsKUyAEgCs4gbLgBYqCG3g/Ax80oJTvBYr5zm5azvfdaIJ8FyDJ9zzsRPmw/x0ky7e/cIT50A7stPnWl7443zhskefbBl6KfNPQUZNvGfyq8g3Dd12+/gNEma/+hNLmQ7k2QJ2/AA01X/chbshXTSVY8qGYtjbln4CGmQ/xxLgx/wwMxHwIp97N+ZBMjXvyIZi6duVfgI6XfwGed9SDJ180vf/pyJf9QfFpz/+pv1iswy85QP+byzHIFgIdG2gyGbBOTMkBVhH+/eU+sAH6ogHzx5QYiJkMcDrS1QK7TAYoRfjZBUyMhyptnekDoH473y7k69hA9TcPdzXrPaD2Yr47C1oHNkBfkktfVMxfFl31qfdLS9P5i+vp2wPqdaXf26JRS3i2TaZlA1WE392qtAiJDNC3i/E3vPG37HmfraJtky152yR/4+fSEAMZWKopkYEQJzJgLIRu//xEBpZxZSIDy/g+kQFtPZmOMpjIgIqwHicRp8QFxLeF70iPKXMB+qEkl9Zod1zgfINPey5wKshm2FOBS6t3A+1wnuvjhd7G+et4ob92Da0BMk9+aAAAAABJRU5ErkJggg==';
  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
      display: flex;
      justify-content: center;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: calc(100% - 76px);

      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .close_btn button {
      width: 24px;
      height: 24px;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 24px;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_wrapper {
      padding: 0 16px;
      margin: 32px 0 16px 0;
      height: 104px;
    }
    .contents_box {
      height: 104px;
    }
    .contents_box .title {
      width: 100%;
      height: 32px;
      margin-bottom: 8px;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 64px;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      
      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick_page {
      padding: 4px 16px;
      position: absolute;
      left: 50%;
      bottom: 64px;
      transform: translate(-50%, 0%);

      display: flex;
      gap: 4px;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      aspect-ratio: 1;
      outline: none;
    }
    .slick_wrapper .slick-list {
      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick-prev {
      width: 24px;
      height: 48px; 

      z-index: 999;
      left: 0;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:before {
      display: none;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next {
      width: 24px;
      height: 48px;

      z-index: 999;
      right: 0;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:before {
      display: none;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }

    .btn_wrapper {
      height: 48px;
      padding: 8px 16px;

      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };

      text-align: left;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      text-align: right;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    @media screen and (min-width: 568px) and (max-width: 1024px) {
      .modal_wrapper {
        width: 314px;        
      }

    }
  `;

  const html =
    `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="contents_wrapper">
          <div class="contents_slider">` +
    text?.multi_title
      ?.map((_: any, idx: number) => {
        return `
        <div class="contents_box">
          <div class="title"><div class="title_inner">${changeEnterHTML(
            text?.multi_title?.[idx]
          )}</div></div>
          <div class="sub_title"><div class="sub_title_inner">${changeEnterHTML(
            text?.multi_sub_title?.[idx]
          )}</div></div>
        </div>
      `;
      })
      .join('') +
    `
          </div>
        </div>
        <div class="slick_wrapper">
          <div class="slick_slider">` +
    bgImage?.multi_image
      ?.map((data: any, idx: number) => {
        return `
        <div>
          <img class="image" src="${
            data && data !== '' ? data : modalSlickAlt
          }" alt="" />
        </div>
      `;
      })
      .join('') +
    `
          </div>
          ${
            bgImage?.multi_image?.length !== 1
              ? `
            <div class="slick_page">
              <span class="slick_number"></span>
              <span class="slash">/</span>
              <span>${bgImage?.multi_image?.length}</span>
            </div>
          `
              : ``
          }
        </div>
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.multi_left_button}
          </button>
          <button class="style02">
            ${btnText?.multi_right_button}
          </button>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = `[`;
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = `[`;
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList(
    'SLIDE MODAL ROUND',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: true,
        infinite: true,
        dots: false,
        speed: 300,
        touchThreshold: 300
      });
  
      $('.contents_slider').slick({
        arrows: false,
        dots: false,
        fade: true,
        speed: 300,
        swipe: false
      });

      let currentIndex = 0;
      let button = ${button_list};
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
      $('.slick_number').text(currentIndex+1);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.contents_slider').slick('goTo', currentIndex);
        $('.slick_number').text(currentIndex+1);
        $('.style01').text(button[currentIndex][0]);
        $('.style02').text(button[currentIndex][1]);
      });

      let deeplink = ${deeplink_list};
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.image').click(function() {
        appboyBridge.logClick(tracking[currentIndex][0]);
        try {
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.style01').click(function() {
        try {
          if (${btnAgain?.type} === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.multi_left_button}", new Date());
          }
          if (${btnAgain?.type} === "event") {
            appboyBridge.logCustomEvent("${btnAgain?.multi_left_button}");
          }
        } catch (err) {}

        appboyBridge.logClick(tracking[currentIndex][1]);
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style02').click(function() {
        appboyBridge.logClick(tracking[currentIndex][2]);
        try {
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
        />

        {/* jquery */}
        <script
          id="test"
          src="https://code.jquery.com/jquery-3.6.0.min.js"
        ></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `               
         (function () {
          function adjustFontSize() {
            var actualSize = Math.round(parseFloat(window.getComputedStyle(document.documentElement).fontSize));
            if (actualSize !== 16) {              
              var newFontSize = (16 * 16) / actualSize;
              document.documentElement.style.fontSize = newFontSize + "px";                            
            }
          }              

          // adjust font size before body load
              adjustFontSize();
              })();                           
          `
          }}
        ></script>
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};

export default SlideModalRoundHTML;
